const n = (t, r = !1) => {
  if (typeof t != "string") return !1;
  const e = t.trim();
  return r ? e.length > 0 : !0;
};
export {
  n as isString
};
